// Resource definition for React Admin
export const feeTemplateChangesResource = {
  name: 'Scheduled Fee Changes',
  fields: {
    id: 'ID',
    templateId: 'Template',
    template: 'Template',
    effectiveDate: 'Effective Date',
    status: 'Status',
    changes: 'Changes',
    reason: 'Reason',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    newStructure: 'New Structure',
    appliedAt: 'Applied At',
    appliedBy: 'Applied By',
    createdBy: 'Created By',
    component: 'Component',
    configuration: 'Configuration',
  },
};

// Custom fee template changes translations
export const feeTemplateChanges = {
  name: 'Scheduled Fee Changes',
  fields: {
    id: 'ID',
    templateId: 'Template',
    template: 'Template',
    effectiveDate: 'Effective Date',
    status: 'Status',
    changes: 'Changes',
    reason: 'Reason',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    newStructure: 'New Structure',
    appliedAt: 'Applied At',
    appliedBy: 'Applied By',
    createdBy: 'Created By',
    component: 'Component',
    configuration: 'Configuration',
    actions: 'Actions',
  },
  status: {
    pending: 'Pending',
    applied: 'Applied',
    cancelled: 'Cancelled',
    overdue: 'Overdue',
    failed: 'Failed',
  },
  empty: {
    title: 'No Scheduled Changes',
    subtitle: 'There are no scheduled fee template changes at this time',
  },
  list: {
    title: 'Scheduled Fee Changes',
    filters: {
      search: 'Search',
      status: 'Status',
      template: 'Template',
      effectiveFrom: 'Effective From',
      effectiveTo: 'Effective To',
    },
  },
  notifications: {
    cancelled: 'Fee template change cancelled successfully',
    cancelFailed: 'Failed to cancel fee template change',
    applied: 'Fee template change applied successfully',
    applyFailed: 'Failed to apply fee template change',
    created: 'Fee template change scheduled successfully',
    updated: 'Fee template change updated successfully',
    deleted: 'Fee template change deleted successfully',
  },
  actions: {
    cancel: 'Cancel',
    apply: 'Apply Now',
    schedule: 'Schedule Change',
    cancelTitle: 'Cancel Scheduled Change',
    cancelConfirm: 'Are you sure you want to cancel this scheduled change? This action cannot be undone.',
    confirmCancel: 'Yes, Cancel Change',
  },
  show: {
    title: 'Fee Template Change Details',
    subtitle: 'View scheduled fee template change information',
    basicInfo: 'Basic Information',
    changeDetails: 'Scheduled Changes',
    changeDetailsApplied: 'Applied Changes',
    noChangesDetected: 'No changes detected between current and new structure',
    appliedAt: 'This change was applied on {date}',
    cancelled: 'This scheduled change has been cancelled',
  },
};